module.exports = "pegasus/assets/theme6/google.png";